
async function getCTOProdsForNav() {

  const domain = 'techmikeny-dev.myshopify.com';
  const storefrontAccessToken = 'c10e82378c6bdb525376d21e11afdc9f';
  
  const graphqlQuery = `
    query collectionByHandle {
      collectionByHandle(handle: "configure-to-order-servers") {
        products(first: 250) {
          edges {
            node {
              handle
              description
              availableForSale
              tags
              title
              totalInventory
              images(first: 1) {
                edges {
                  node {
                    src
                  }
                }
              }
              variants(first: 1) {
                nodes {
                  sku
                  price {
                    amount
                  }
                }
              }
            }
          }
        }
      }
    }
  `;
  
  const response = await fetch(`https://${domain}/api/2023-10/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: JSON.stringify({ query: graphqlQuery })
  });
  
  if (!response.ok) throw new Error('Network response was not ok');
  
  const responseData = await response.json();
  
  if (responseData.errors) {
    throw new Error(`GraphQL errors: ${responseData.errors.map(e => e.message).join(', ')}`);
  }
  
  if (!responseData.data?.collectionByHandle?.products?.edges) {
    throw new Error('Invalid response structure');
  }
  
  const products = responseData.data.collectionByHandle.products.edges.map(edge => {
    const node = edge.node;
    return {
      handle: node.handle,
      description: node.description,
      title: node.title,
      tags: node.tags,
      availableForSale: node.availableForSale,
      images: node.images?.edges?.map(imgEdge => ({
        src: imgEdge.node.src
      })) || [],
      variants: node.variants?.nodes?.map(variant => ({
        price: variant.price?.amount || '0.00',
        sku: variant.sku
      })) || []
    };
  });
  
  const availableProducts = products.filter(product => 
    product.availableForSale === true
  );
  
  
  window.availableProducts = availableProducts;

}


window.addEventListener('DOMContentLoaded', (event) => {
    getCTOProdsForNav()
});